<template>
  <section
    class="invoice-preview-wrapper"
  >
    <div
      class="invoice-preview d-flex flex-wrap"
    >
      <!-- Col: Left (Invoice Container) -->
      <div
        v-if="showDefaultLayout && $route.params.waybillId !== 4 && $route.params.waybillId !== 5"
        class="invoice-preview-col"
      >
        <b-card
          v-for="(dispatch, index) in chunkedDispatchNotes"
          id="invoice-preview-card"
          :key="index"
          no-body
          class="invoice-preview-card"
          style="width:930px;"
        >
          <!-- Header -->
          <b-card-body
            class="invoice"
          >
            <b-row
              id="invoiceTableParent"
              class="d-flex flex-wrap"
            >
              <b-col
                v-for="(dispatchNote, index1) in dispatch"
                :id="dispatchNote.id"
                :key="index1"
              >
                <table
                  class="table-border"
                  style="width:430px;"
                >
                  <tr
                    class="table-padding"
                  >
                    <td>
                      <span class="brand-logo">
                        <b-img
                          class="dn-brand-logo"
                          :src="courier.company_logo ? `${bucketUrl}${courier.company_logo}` : defaultCompanyLogo"
                          alt="logo"
                        />
                      </span>
                    </td>
                    <td>
                      <div style="float: right">
                        <h5 class="dn-waybill">
                          Waybill ID : {{ dispatchNote.waybill_number }}
                        </h5>
                        <div
                          style="padding-right:10px;"
                        >
                          <Barcode
                            :id="dispatchNote.waybill_number"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    class="table-padding"
                    height="110px"
                  >
                    <td>
                      <h4
                        class="dn-business-name"
                      >
                        {{ courier.company_name }}
                      </h4>
                      <span class="dn-business-detail"> {{ courier.company_address }} <br> {{ courier.company_phone }} </span>
                    </td>
                    <td>
                      <div style="float: right">
                        <td>
                          <div>
                            <QRcode
                              :id="dispatchNote.waybill_number"
                            />
                          </div>
                        </td>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <table width="100%">
                        <!-- row01 -->
                        <tr
                          class="dn-border-top"
                        >
                          <td
                            class="dn-border-right col-sm-6"
                          >
                            <h4 class="dn-sub-header">
                              Merchant Details
                            </h4>
                          </td>
                          <td class="col-sm-6">
                            <h4 class="dn-sub-header">
                              Customer Details
                            </h4>
                          </td>
                        </tr>
                        <!-- row02 -->
                        <tr
                          class="dn-border-top"
                          height="170px"
                        >
                          <td
                            class="dn-border-right col-sm-6"
                          >
                            <div class="dn-valign">
                              <h5 class="dn-content-header">
                                Name
                              </h5>
                              <span class="dn-content">{{ dispatchNote.merchant_business.business_name }}</span>
                            </div>
                            <div class="dn-valign">
                              <h5 class="dn-content-header">
                                Address
                              </h5>
                              <span class="dn-content">
                                {{ dispatchNote.merchant_business_address ? dispatchNote.merchant_business_address.address_line_1 : '---' }} <br>
                                {{ dispatchNote.merchant_business_address ? dispatchNote.merchant_business_address.address_line_2 : '---' }} <br>
                                {{ dispatchNote.merchant_business_address ? dispatchNote.merchant_business_address.address_line_3 : '---' }}
                              </span>
                            </div>
                            <div class="dn-valign">
                              <h5 class="dn-content-header">
                                Telephone
                              </h5>
                              <span class="dn-content">{{ dispatchNote.merchant_business_address ? dispatchNote.merchant_business_address.phone : '---' }}</span>
                            </div>
                          </td>
                          <td class="col-sm-6">
                            <div class="dn-valign">
                              <h5 class="dn-content-header">
                                Name
                              </h5>
                              <span class="dn-content">{{ dispatchNote.customer_name }}</span>
                            </div>
                            <div class="dn-valign">
                              <h5 class="dn-content-header">
                                Address
                              </h5>
                              <span class="dn-content text-break">{{ dispatchNote.customer_address }}</span>
                            </div>
                            <div class="dn-valign">
                              <h5 class="dn-content-header">
                                Telephone
                              </h5>
                              <span class="dn-content">{{ dispatchNote.concated_phone_number }}</span>
                            </div>
                          </td>
                        </tr>
                        <!-- row03 -->
                        <tr
                          class="dn-border-top"
                        >
                          <td colspan="2">
                            <h4 class="dn-sub-header">
                              Order Details
                            </h4>
                          </td>
                        </tr>
                        <!-- row04 -->
                        <tr class="dn-border-top">
                          <td
                            class="dn-border-right col-sm-6"
                            style="padding-bottom:10px;"
                          >
                            <div style="margin-top:6px">
                              <h5 class="dn-content-header">
                                Order Number
                              </h5>
                              <span class="dn-content">{{ dispatchNote.order_no }}</span>
                            </div>
                            <div>
                              <h5 class="dn-content-header">
                                Order Date
                              </h5>
                              <span class="dn-content">{{ __dateTimeFormatter(dispatchNote.created_at) }}</span>
                            </div>
                            <div>
                              <h5 class="dn-content-header">
                                Postal / Zip Code
                              </h5>
                              <span class="dn-content">{{ dispatchNote.city.postal_code }}</span>
                            </div>
                            <div>
                              <h5 class="dn-content-header">
                                Weight
                              </h5>
                              <span class="dn-content"> {{ dispatchNote.weight }}Kg </span>
                            </div>
                          </td>
                          <td class="d-flex flex-column justify-content-start w-100%">
                            <div style="height:70px;margin-top:6px">
                              <h5 class="dn-content-header">
                                Description
                              </h5>
                              <span class="dn-content">
                                {{ dispatchNote.description? dispatchNote.description.substring(0,55) : 'N/A' }}
                              </span>
                            </div>
                            <div style="margin-top:10px">
                              <h5 class="dn-content-header">
                                City
                              </h5>
                              <span class="dn-content">
                                {{ dispatchNote.city.name }}
                              </span>
                            </div>
                            <div>
                              <h5 class="dn-content-header">
                                Total COD
                              </h5>
                              <span class="dn-content">
                                Rs. {{ dispatchNote.cod }}
                              </span>
                            </div>
                          </td>
                        </tr>
                        <tr
                          class="dn-border-top"
                        >
                          <td
                            colspan="100%"
                            class="curfox-label font-small-2"
                          >
                            Powered By Curfox.com
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </b-col>
            </b-row>
            <!--        </div>-->
          </b-card-body>
        </b-card>
      </div>
      <!-- Custom Layout for waybillId === 4 -->
      <div
        v-else-if="$route.params.waybillId === 4"
      >
        <b-card
          v-for="(dispatchChunk, chunkIndex) in chunkedDispatchNotes"
          :key="`card-chunk-${chunkIndex}`"
          no-body
          class="invoice-preview-card waybill-a6-card"
        >
          <b-card-body
            class="invoice"
            style="padding: 0;"
          >
            <div
              class="waybill-a6-container"
            >
              <div
                v-for="(dispatchNote, index1) in dispatchChunk"
                :key="index1"
                class="waybill-a6-quadrant"
              >
                <!-- Company Header -->
                <div class="waybill-header">
                  <b-img
                    class="waybill-logo"
                    :src="courier.company_logo ? `${bucketUrl}${courier.company_logo}` : defaultCompanyLogo"
                    alt="logo"
                  />
                  <div class="waybill-company-info">
                    <h5 class="waybill-company-name">
                      {{ courier.company_name }}
                    </h5>
                    <span class="waybill-company-phone">{{ formattedCompanyPhone }}</span>
                  </div>
                </div>
                <hr class="a6-hr-1">
                <!-- Waybill ID and Barcode/QR Code -->
                <div class="waybill-id-section">
                  <div class="waybill-barcode-group">
                    <h5 class="waybill-id-text">
                      Waybill ID : {{ dispatchNote.waybill_number }}
                    </h5>
                    <Barcode
                      :id="dispatchNote.waybill_number"
                      class="waybill-barcode-img"
                    />
                  </div>
                  <div class="d-flex align-items-center h-100">
                    <QRcode
                      :id="dispatchNote.waybill_number"
                      class="waybill-qrcode-img"
                    />
                  </div>
                </div>

                <!-- Customer Details Card -->
                <div class="waybill-card waybill-customer-details">
                  <div class="waybill-card-header">
                    <h5 class="customer-details-title">
                      Customer Details
                    </h5>
                    <span class="waybill-card-phone">
                      <feather-icon
                        icon="PhoneCallIcon"
                        size="14"
                      /> {{ dispatchNote.customer_phone }}<span v-if="dispatchNote.customer_secondary_phone"> / {{ dispatchNote.customer_secondary_phone }}</span>
                    </span>
                  </div>
                  <p class="waybill-customer-name">
                    {{ dispatchNote.customer_name }}
                  </p>
                  <span class="waybill-customer-address">
                    Address : <span class="waybill-order-bold">{{ dispatchNote.customer_address }}</span>
                  </span>
                </div>

                <!-- Order Summary Card -->
                <div class="waybill-card waybill-order-summary">
                  <div class="d-flex justify-content-between">
                    <h5 class="waybill-card-title">
                      Order Summary
                    </h5>
                    <div class="waybill-order-line-1">
                      <span class="waybill-order-item weight">
                        <feather-icon
                          icon="PackageIcon"
                          size="10"
                          class="box-icon"
                        /> {{ dispatchNote.weight }}Kg</span>
                      <span class="waybill-order-item">Order No. : <span class="waybill-order-bold">{{ dispatchNote.order_no }}</span></span>
                    </div>
                  </div>
                  <div class="waybill-order-line-2">
                    <span class="waybill-order-item">City : <span class="waybill-order-bold">{{ dispatchNote.city.name }}</span></span>
                    <span class="waybill-order-item">Order Date : <span class="waybill-order-bold">{{ __dateTimeFormatter(dispatchNote.created_at) }}</span></span>
                  </div>
                  <span class="waybill-order-item waybill-order-description">
                    Description : <span class="waybill-order-bold">{{ dispatchNote.description? dispatchNote.description : 'N/A' }}</span>
                  </span>
                </div>

                <!-- Total COD Card -->
                <div class="waybill-card waybill-total-cod">
                  <h4 class="waybill-cod-value">
                    Total COD : Rs. {{ dispatchNote.cod }}
                  </h4>
                </div>
                <hr class="a6-hr-2">
                <!-- Merchant Details Card -->
                <div class="waybill-merchant-details">
                  <h5 class="waybill-card-title">
                    Merchant Details
                  </h5>
                  <div class="waybill-merchant-line">
                    <span class="waybill-merchant-name">{{ dispatchNote.merchant_business.business_name }}</span>
                    <span class="waybill-merchant-contact">Contact : {{ dispatchNote.admin ? dispatchNote.admin.phone : '---' }}</span>
                  </div>
                  <div class="waybill-merchant-second-phone">
                    <span class="waybill-merchant-contact">{{ dispatchNote.merchant_business_address ? dispatchNote.merchant_business_address.phone : '---' }}</span>
                  </div>
                </div>

                <!-- Powered By -->
                <div class="waybill-powered-by">
                  Powered By Curfox.com
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <!-- Custom Layout for waybillId === 5 (Ten By Ten - Fixed) -->
      <div
        v-else-if="$route.params.waybillId === 5"
      >
        <b-card
          v-for="(dispatchChunk, chunkIndex) in chunkedDispatchNotes"
          :key="`card-chunk-${chunkIndex}`"
          no-body
          class="invoice-preview-card ten-by-ten-card-fixed table-ten-by-ten"
        >
          <b-card-body
            class="invoice"
            style="padding: 0;"
          >
            <div
              class="waybill-container-ten"
            >
              <div
                v-for="(dispatchNote, index1) in dispatchChunk"
                :key="index1"
                class="waybill-ten-single"
              >
                <!-- Company Header -->
                <div class="waybill-card-ten">
                  <div class="waybill-header-ten">
                    <b-img
                      class="waybill-logo-ten"
                      :src="courier.company_logo ? `${bucketUrl}${courier.company_logo}` : defaultCompanyLogo"
                      alt="logo"
                    />
                    <div class="waybill-company-info-ten">
                      <h5 class="waybill-company-name-ten">
                        {{ courier.company_name }}
                      </h5>
                      <span class="waybill-company-phone-ten">{{ formattedCompanyPhone }}</span>
                    </div>
                  </div>
                  <!-- Waybill ID and Barcode/QR Code -->
                  <div class="waybill-id-section-ten">
                    <div class="waybill-barcode-group-ten">
                      <Barcode
                        :id="dispatchNote.waybill_number"
                        class="waybill-barcode-img-ten"
                      />
                    </div>
                  </div>
                </div>

                <!-- Customer Details Card -->
                <div class="waybill-card-ten waybill-customer-details-ten">
                  <div class="waybill-card-header-ten">
                    <h5 class="customer-details-title">
                      Customer Details
                    </h5>
                    <span class="waybill-card-phone-ten">
                      <feather-icon
                        icon="PhoneCallIcon"
                        size="14"
                      /> {{ dispatchNote.customer_phone }}<span v-if="dispatchNote.customer_secondary_phone"> / {{ dispatchNote.customer_secondary_phone }}</span>
                    </span>
                  </div>
                  <p class="waybill-customer-name-ten">
                    {{ dispatchNote.customer_name }}
                  </p>
                  <span class="waybill-customer-address-ten">
                    Address : <span class="waybill-order-bold">{{ dispatchNote.customer_address }}</span>
                  </span>
                </div>

                <!-- Order Summary Card -->
                <div class="waybill-card-ten waybill-order-summery-ten">
                  <div class="waybill-card-header-ten">
                    <h5 class="waybill-card-title-ten">
                      Order Summary
                    </h5>
                    <div class="waybill-order-line-1">
                      <span class="waybill-order-item-ten">
                        {{ dispatchNote.weight }}Kg</span>
                    </div>
                  </div>
                  <span class="waybill-order-item-ten waybill-order-description-ten">
                    Description : <span class="waybill-order-bold">{{ dispatchNote.description? dispatchNote.description : 'N/A' }}</span>
                  </span>
                  <div class="waybill-total-cod-ten">
                    <h4 class="waybill-cod-value-ten">
                      Total COD : Rs. {{ dispatchNote.cod }}
                    </h4>
                  </div>
                </div>
                <!-- Merchant Details Card -->
                <div class="waybill-merchant-details-ten">
                  <h5 class="waybill-card-title-ten">
                    Merchant Details
                  </h5>
                  <div class="waybill-merchant-line">
                    <span class="waybill-merchant-name-ten">{{ dispatchNote.merchant_business.business_name }}</span>
                    <span class="waybill-merchant-contact-ten">Contact : {{ dispatchNote.admin ? dispatchNote.admin.phone : '---' }}</span>
                  </div>
                  <div class="waybill-merchant-second-phone-ten">
                    <span class="waybill-merchant-contact-ten">{{ dispatchNote.merchant_business_address ? dispatchNote.merchant_business_address.phone : '---' }}</span>
                  </div>
                </div>

                <!-- Powered By -->
                <div class="waybill-powered-by-ten">
                  Powered By Curfox.com
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div
        v-else-if="waybillLayout && $route.params.waybillId !== 4 && $route.params.waybillId !== 5"
        id="custom-invoice-preview-col"
        class="invoice-preview-col"
      />
      <!-- Right Col: Card -->
      <b-col
        class="invoice-actions"
      >
        <b-card>
          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-warning"
            class="mb-75"
            block
            @click="printInvoice"
          >
            Print
          </b-button>
        </b-card>
      </b-col>
    </div>
  </section>
</template>

<script>
import {
  BRow, BCol, BCard, BCardBody, BButton, BImg,
} from 'bootstrap-vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Vue from 'vue'
import Ripple from 'vue-ripple-directive'
import _ from 'lodash'
import { bucketUrl, defaultCompanyLogo } from '@/constants/config'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Barcode from '@/components/print/Barcode.vue'
import QRcode from '@/components/print/QRcode.vue'

const OrderRepository = RepositoryFactory.get('order')
const LayoutRepository = RepositoryFactory.get('layout')

export default {
  directives: {
    Ripple,
  },
  components: {
    QRcode,
    Barcode,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BImg,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      courier: {},
      dispatchNotes: [],
      bucketUrl,
      defaultCompanyLogo,
      showDefaultLayout: false,
      waybillLayout: null,
      loading: false,
      waybillsPerCanvas: 4,
      isTenByTen: false,
    }
  },
  computed: {
    chunkedDispatchNotes() {
      if (this.$route.params.waybillId === 4 || this.$route.params.waybillId === 5) {
        return _.chunk(this.dispatchNotes, this.$route.params.waybillId === 4 ? 4 : 1) // For 4 it's 4 per canvas, for 5 it's 1 per canvas (each is its own 10x10)
      }
      return _.chunk(this.dispatchNotes, this.waybillsPerCanvas)
    },
    formattedCompanyPhone() {
      if (!this.courier || !this.courier.company_phone) {
        return ''
      }
      const phone = String(this.courier.company_phone)
      if (phone.length < 10) {
        return phone
      }
      return `${phone.slice(0, 4)} ${phone.slice(4, 7)} ${phone.slice(7, 11)}`
    },
  },
  async mounted() {
    this.courier = JSON.parse(localStorage.getItem('businessSettings'))
    await this.getOrdersByWaybills()
    // Handle waybillId = 4 specifically and prevent fetching dynamic layout
    if (this.$route.params.waybillId === 4 || this.$route.params.waybillId === 5) {
      this.showDefaultLayout = false // Ensure custom layout is rendered
    } else {
      await this.getWaybillLayout() // This method should only be called for non-'4' IDs
      if (this.waybillLayout) {
        this.initWaybillLayout()
      } else {
        this.showDefaultLayout = true // Fallback to default if no dynamic layout is found
      }
    }
  },
  methods: {
    async getOrdersByWaybills() {
      try {
        this.loading = true
        const { data } = (await OrderRepository.getPODOrdersByWaybills(this.$route.params.selectedWaybills))
        this.dispatchNotes = data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async getWaybillLayout() {
      try {
        this.loading = true
        const { data } = (await LayoutRepository.getWaybillLayoutDetail(this.$route.params.waybillId))
        this.waybillLayout = data.data.template
        this.waybillsPerCanvas = data.data.waybills_per_canvas
        // Check if layout is 10x10
        this.isTenByTen = this.waybillLayout && this.waybillLayout.includes('table-ten-by-ten')
      } catch (e) {
        this.showErrorMessage('Couldn\'t fetch waybill layout!')
      }
      this.loading = false
    },
    initWaybillLayout() {
      const container = document.getElementById('custom-invoice-preview-col')
      const removals = ['draggable', 'resizable', 'resize-drag', 'resize-drag-vertical', 'resize-drag-horizontal', 'contenteditable']
      removals.forEach(removal => {
        this.waybillLayout = this.waybillLayout.replaceAll(removal, '')
      })
      this.chunkedDispatchNotes.forEach(chunk => {
        const tempElement = document.createElement('div')
        tempElement.classList.add('invoice-preview-card')
        tempElement.style.width = '930px'
        tempElement.innerHTML = this.waybillLayout
        container.appendChild(tempElement)
        const outOfPlaceList = []
        document.getElementById('invoiceTableParent').children.forEach(child => {
          if (child.tagName !== 'TABLE') {
            const copy = child.cloneNode(true)
            outOfPlaceList.push(copy)
          } else {
            document.getElementById('invoiceTableParent').innerHTML = child.outerHTML
          }
        })
        const tableParent = document.getElementById('invoiceTableParent')
        const tableInnerHTML = document.getElementById('invoiceTableParent').innerHTML
        document.getElementById('invoiceTable').remove()
        document.querySelectorAll('.customComponent').forEach(element => {
          element.remove()
        })
        if (document.querySelector('#barcode_CF000000')) {
          document.querySelector('#barcode_CF000000').remove()
        }
        if (document.querySelector('#qrcode_CF000000')) {
          document.querySelector('#qrcode_CF000000').remove()
        }
        chunk.map(async dispatchNote => {
          const tableToModify = tableInnerHTML
          const invoiceElement = document.createElement('div')
          invoiceElement.classList.add('col')
          invoiceElement.innerHTML = tableToModify
          tableParent.appendChild(invoiceElement)
          const newTable = document.getElementById('invoiceTable')
          // eslint-disable-next-line array-callback-return
          outOfPlaceList.map(child => {
            newTable.insertAdjacentElement('afterbegin', child)
          })
          newTable.id = `id${(new Date()).getTime()}`
          newTable.classList.add('invoiceTable')
          tableParent.id = `id${(new Date()).getTime()}`
          const mappers = [
            {
              key: '-- business_name --',
              value: dispatchNote.merchant_business.business_name || 'N/A',
            },
            {
              key: '-- address_line_1 --',
              value: dispatchNote.merchant_business_address ? dispatchNote.merchant_business_address.address_line_1 : '---',
            },
            {
              key: '-- address_line_2 --',
              value: dispatchNote.merchant_business_address ? dispatchNote.merchant_business_address.address_line_2 : '---',
            },
            {
              key: '-- address_line_3 --',
              value: dispatchNote.merchant_business_address ? dispatchNote.merchant_business_address.address_line_3 : '---',
            },
            {
              key: '-- phone --',
              value: dispatchNote.merchant_business_address ? dispatchNote.merchant_business_address.phone : '---',
            },
            {
              key: '-- customer_name --',
              value: dispatchNote.customer_name || 'N/A',
            },
            {
              key: '-- customer_address --',
              value: dispatchNote.customer_address || 'N/A',
            },
            {
              key: '-- concated_phone_number --',
              value: dispatchNote.concated_phone_number || 'N/A',
            },
            {
              key: '-- customer_secondary_phone --',
              value: dispatchNote.customer_secondary_phone || '',
            },
            {
              key: '-- waybill_number --',
              value: dispatchNote.waybill_number || 'N/A',
            },
            {
              key: '-- order_no --',
              value: dispatchNote.order_no || 'N/A',
            },
            {
              key: '-- created_at --',
              // eslint-disable-next-line no-underscore-dangle
              value: this.__dateTimeFormatter(dispatchNote.created_at),
            },
            {
              key: '-- city.postal_code --',
              value: dispatchNote.city.postal_code || 'N/A',
            },
            {
              key: '-- weight --',
              value: dispatchNote.weight || 'N/A',
            },
            {
              key: '-- description --',
              value: dispatchNote.description ? dispatchNote.description.substring(0, 55) : 'N/A',
            },
            {
              key: '-- city.name --',
              value: dispatchNote.city.name || 'N/A',
            },
            {
              key: '-- warehouse.name --',
              value: dispatchNote.warehouse.name || 'N/A',
            },
            {
              key: '-- cod --',
              value: dispatchNote.cod ?? 'N/A',
            },
            {
              key: '-- delivery_charge --',
              value: dispatchNote.delivery_charge || 'N/A',
            },
          ]
          mappers.forEach(mapper => {
            newTable.innerHTML = newTable.innerHTML.replaceAll(mapper.key, mapper.value)
          })
          newTable.innerHTML = newTable.innerHTML.replaceAll('customComponent', '')
          if (this.waybillLayout.includes('barcode_CF000000')) {
            const barcodeStyle = document.getElementById('barcode_CF000000').style.cssText
            new Vue({
              ...Barcode,
              propsData: {
                id: dispatchNote.waybill_number,
              },
            }).$mount('#barcode_CF000000')
            document.getElementById(`barcode_${dispatchNote.waybill_number}`).style.cssText = barcodeStyle
          }
          if (this.waybillLayout.includes('qrcode_CF000000')) {
            const qrStyle = document.getElementById('qrcode_CF000000').style.cssText
            new Vue({
              ...QRcode,
              propsData: {
                id: dispatchNote.waybill_number,
              },
            }).$mount('#qrcode_CF000000')
            document.getElementById(`qrcode_${dispatchNote.waybill_number}`).style.cssText = qrStyle
          }
        })
      })
    },
    async printInvoice() {
      // For 10x10 layouts, set page size to 10cm x 10cm
      if (this.isTenByTen || this.$route.params.waybillId === 5) {
        const style = document.createElement('style')
        style.id = 'ten-by-ten-page-size'
        style.textContent = '@page { size: 10cm 10cm; margin: 0; }'
        document.head.appendChild(style)
        window.print()
        // Remove the style after printing
        this.$nextTick(() => {
          const styleEl = document.getElementById('ten-by-ten-page-size')
          if (styleEl) {
            styleEl.remove()
          }
        })
      } else if (this.$route.params.waybillId === 4) {
        const style = document.createElement('style')
        style.id = 'a4-page-size'
        style.textContent = '@page { margin: 2mm; }'
        document.head.appendChild(style)
        window.print()
        this.$nextTick(() => {
          const styleEl = document.getElementById('a4-page-size')
          if (styleEl) {
            styleEl.remove()
          }
        })
      } else {
        window.print()
      }
    },
  },
}
</script>

<style lang="scss">
@import "../../@core/scss/base/pages/app-invoice.scss";

@page {
    size: A4 portrait;
    margin: 10mm;
  }
.dn-business-name {
  padding-left: 15px;
  font-size: 17px;
  font-weight: bolder;
  color: black;
}
.dn-business-detail {
  display: inline-block;
  padding-left: 15px;
  font-size: 13px;
  color: black;
}
.dn-brand-logo {
  display: block;
  width: 90px;
  height: 90px;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
  float: left;
  border-radius: 20px;
}
.dn-border-top {
  border-top: solid black 2px;
}
.dn-border-right {
  border-right: solid black 2px;
}
.dn-border-bottom {
  border-bottom: solid black 2px;
}
.dn-border-left {
  border-left: solid black 2px;
}

.dn-waybill {
  padding: 10px 5px 5px 0;
  font-weight: bolder;
  color: black;
  text-align: right;
  font-size: 15px;
}
.dn-sub-header {
  padding-top: 5px;
  text-align: center;
  font-size: 13px;
  font-weight: bolder;
  color: black;
}
.dn-city-cod {
  padding: 5px 0 0 5px;
  font-size: 18px;
  font-weight: bolder;
  color: black;
  text-align: center;
}
.dn-content-header {
  padding: 3px 0 0 5px;
  font-size:13px;
  font-weight: bolder;
  margin-bottom: 2px;
}
.dn-content {
  padding-left: 5px;
  font-size: 13px;
  display:inline-block;
  color: black;
  font-weight: 400;
}
.table-ten-by-ten {
  .dn-content {
    font-size: 17px !important;
  }
  .sub-row-content {
    padding-top: 37px !important;
  }
  .dn-content-header {
    font-size: 17px !important;
    padding-top: 40px !important;
  }
}
.dn-valign {
  vertical-align: top;
}
.invoice-preview-col {
  overflow-y: auto;
}
.invoice-table-parent {
  margin-left: 0 !important;
}
.table-border {
  border: solid black 2px;
}
table {
    table-layout:auto !important;
}
.curfox-label {
    padding: 2px;
    text-align: center;
    font-weight: bolder;
    column-span: all !important;
    color: black;
}
.black-components,
.dn-business-name,
.dn-business-detail,
.dn-waybill,
.dn-sub-header,
.dn-city-cod,
.dn-content-header,
.dn-content,
.dn-valign,
.curfox-label {
  font-family: "Arial", sans-serif;
  color: black;
  font-weight: bolder !important;
}

// NEW CUSTOM STYLES FOR WAYBILL ID 4 LAYOUT
.waybill-a6-card {
  width: 248mm;
  height: 358mm;
}

.waybill-a6-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.waybill-a6-quadrant {
  width: 122mm;
  height: 177mm;
  border: 1px solid black; /* Ensure border is visible in print */
  padding: 1mm;
  margin: 1mm;
  box-sizing: border-box;
  overflow: hidden;
  font-family: "Arial", sans-serif;
  color: black;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Distribute space vertically */
}

/* Common Text Styles */
.waybill-bold { font-weight: bold; }
.waybill-color-black { color: black; }

/* Header Section */
.waybill-header {
  display: flex;
  align-items: center;
  margin: 2mm 1mm 2mm 1mm;
}
.waybill-logo {
  width: 25mm;
  height: 12mm;
  object-fit: contain;
  margin-right: 1mm;
  flex-shrink: 0;
}
.waybill-company-info {
  flex-grow: 1;
  text-align: right;
  line-height: 1.5;
}
.waybill-company-name {
  margin: 0;
  font-size: 1.1rem;
  color: #000;
  font-weight: bold;
}
.waybill-company-phone {
  font-size: 1rem;
  color: #000;
}

.a6-hr-1 {
  margin: 2mm 1mm 0 1mm;
  border-top: 1px solid #000;
}

.a6-hr-2 {
  margin: 0 0 1mm 0;
  border-top: 1px solid #000;
}

/* Waybill ID Section */
.waybill-id-section {
  margin: 1mm 1mm 4mm 1mm;
  display: flex;
  align-items: flex-end; /* Align barcode group and QR code at the bottom */
  justify-content: space-between;
}
.waybill-barcode-group {
  display: flex;
  flex-direction: column;
  align-items: center; /* Center barcode number below barcode */
}
.waybill-id-text {
  margin: 0;
  font-size: 0.9rem;
  color: #000;
  font-weight: bold;
  width: 100%; /* Ensure text takes full width for centering */
  text-align: left;
}
.waybill-barcode-img {
  width: 60mm;
  height: 10mm;
  margin-top: 2mm;
  display: block;
}
.waybill-barcode-number {
  font-size: 0.9rem;
  color: #000;
  font-weight: bold;
  display: block;
  text-align: center;
  margin-top: 0.5mm;
}
.waybill-qrcode-img {
  width: 22mm !important;
  height: 20mm !important;
  display: block;
}

/* Card Common Styles */
.waybill-card {
  border: 1px solid black;
  border-radius: 5px;
  padding: 2mm 2mm;
  margin-bottom: 4mm;
  display: flex;
  flex-direction: column;
}
.waybill-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1mm;
}
.waybill-card-title {
  margin: 0;
  font-size: 0.9rem;
  color: #000;
  font-weight: bold;
}
.customer-details-title {
  font-size: 1.3rem;
  color: #000;
  font-weight: bold;
  margin-bottom: 0;
}
.waybill-card-phone {
  font-size: 1.3rem;
  color: #000;
  font-weight: bold;
}
.waybill-customer-name {
  margin: 2mm 0;
  font-size: 1.3rem;
  color: #000;
  font-weight: bold;
  line-height: 1.2;
}
.waybill-customer-address {
  margin: 1mm 0;
  font-size: 1.3rem;
  color: #000;
  line-height: 1.2;
}
.waybill-order-summary {
  padding-top: 4mm;
}
.waybill-order-line-1 {
  display: flex;
  justify-content: center;
}

.waybill-order-line-1 .weight {
  margin-right: 1mm;
  display: flex;
  align-items: center;
}

.waybill-order-line-1 .weight .box-icon {
  margin-right: 0.5mm;
}

.waybill-order-line-2 {
  display: flex;
  justify-content: space-between;
  margin: 3mm 0 2mm 0;
}
.waybill-order-item {
  font-size: 0.9rem;
  color: #000;
}
.waybill-order-bold {
  font-weight: bold;
}

.waybill-order-description {
  margin: 1mm 0 3mm 0;
}

/* Total COD Card */
.waybill-total-cod {
  text-align: center;
  padding-top: 3mm;
  padding-bottom: 3mm;
}
.waybill-cod-value {
  margin: 0;
  font-size: 0.9rem;
  color: #000;
  font-weight: bold;
}

/* Merchant Details Card */
.waybill-merchant-details {
  margin-top: 3mm;
  border: 1px solid #d2d2d2;
  border-radius: 5px;
}
.waybill-merchant-details h5 {
  padding: 3mm 2mm;
}
.waybill-merchant-line {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #d2d2d2;
  padding: 3mm 2mm 0 2mm;
}
.waybill-merchant-name {
  font-size: 0.9rem;
  color: #000;
}
.waybill-merchant-contact {
  font-size: 0.9rem;
  color: #000;
}
.waybill-merchant-second-phone {
  display: flex;
  justify-content: end;
  padding: 0 2mm 3mm 0;
}

/* Powered By Footer */
.waybill-powered-by {
  text-align: center;
  font-size: 0.9rem; /* Slightly smaller for footer */
  margin-top: auto; /* Pushes it to the bottom */
  color: #000;
  font-weight: bold;
}

//new 10*10
.ten-by-ten-card-fixed {
  width: 140mm;
  height: 140mm;
}

.waybill-container-ten {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.waybill-ten-single {
  border: 1px solid black; /* Ensure border is visible in print */
  margin: 1mm;
  box-sizing: border-box;
  overflow: hidden;
  font-family: "Arial", sans-serif;
  color: black;
  width: 138mm;
  height: 138mm;
  display: flex; /* Add this */
  flex-direction: column;
}

.waybill-header-ten {
  display: flex;
  align-items: center;
  padding: 1mm 1mm 0 1mm;
}

.waybill-logo-ten {
  width: 30mm;
  height: 15mm;
  object-fit: contain;
  margin-right: 10mm;
  flex-shrink: 0;
}
.waybill-company-info-ten {
  flex-grow: 1;
  text-align: left;
  line-height: 2;
}
.waybill-company-name-ten {
  margin: 0;
  font-size: 1.2rem;
  color: #000;
  font-weight: bold;
}
.waybill-company-phone-ten {
  font-size: 1rem;
  color: #000;
}

.waybill-card-ten {
  border-bottom: 1px solid black;
}

.waybill-id-section-ten {
  margin-bottom: 2mm;
  display: flex;
  justify-content: end;
}

.waybill-barcode-group-ten {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 75%;
}

.waybill-barcode-img-ten {
  width: 60mm;
  height: 10mm;
  display: block;
}

.waybill-customer-details-ten {
  padding: 2mm;
}

.waybill-card-title-ten {
  margin: 0;
  font-size: 0.9rem;
  color: #000;
  font-weight: bold;
}

.waybill-order-summery-ten {
  padding: 3mm 2mm;
}

.waybill-card-phone-ten {
  font-size: 1.3rem;
  color: #000;
  font-weight: bold;
}
.waybill-customer-name-ten {
  margin: 0 0 3mm 0;
  font-size: 1.3rem;
  color: #000;
  font-weight: bold;
  line-height: 1.2;
}
.waybill-customer-address-ten {
  margin: 0;
  line-height: 1.2;
  font-size: 1.3rem;
  color: #000;
}

.waybill-order-item-ten {
  font-size: 0.9rem;
  color: #000;
}

.waybill-order-description-ten {
  margin: 0;
  line-height: 1;
}

.waybill-total-cod-ten {
  border: 1px solid black;
  border-radius: 5px;
  padding: 2mm 1mm;
  margin-top: 2mm;
  display: flex;
  flex-direction: column;
  text-align: center;
}

.waybill-cod-value-ten {
  margin: 0;
  font-size: 0.9rem;
  color: #000;
  font-weight: bold;
}

.waybill-merchant-details-ten {
  margin: 3mm 2mm;
  border: 1px solid #d2d2d2;
  border-radius: 5px;
}

.waybill-merchant-details-ten h5 {
  padding: 2mm 1mm;
}

.waybill-merchant-name-ten {
  font-size: 0.9rem;
  color: #000;
}
.waybill-merchant-contact-ten {
  font-size: 0.9rem;
  color: #000;
}
.waybill-merchant-second-phone-ten {
  display: flex;
  justify-content: end;
  padding: 0 2mm 3mm 0;
}

/* Powered By Footer */
.waybill-powered-by-ten {
  text-align: center;
  font-size: 0.9rem; /* Slightly smaller for footer */
  margin-top: auto;
  margin-bottom: 1mm;
  color: #000;
  font-weight: bold;
}

.waybill-card-header-ten {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3mm;
}

@media print {
  // Global Styles
  .col-sm-6 {
    width: 25mm;
  }
  body {
    width: 210mm;
    height: 296mm;
    overflow:hidden;
    background: #fff !important;
    background-color: #fff !important;
  }
  * {
    outline: none !important;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
  }
  .custom-h5.dn-waybill {
    font-size: 16px !important;
    color: black !important;
    font-weight: bold !important;
  }
 .invoiceTable {
    outline: solid black 3px !important;
    border: none !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content-header {
    display: none;
  }
  .content.app-content {
    margin: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
    overflow:hidden;
  }
  .customizer-toggle {
    display: none !important;
  }
  // Invoice Specific Styles
  .invoice-preview-wrapper {
    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
  .invoice-preview {
    display: block;
  }
  .invoice {
    position: relative;
    display: block;
  }
  .invoice-preview-col {
    display: block;
  }
  .invoice-preview-card {
    display: block;
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .invoice-preview-card:not(:last-child) {
    break-after: always;
    page-break-after: always;
  }
  section span, section p, section div {
    font-weight: 600 !important;
  }
  .black-components,
  .dn-business-name,
  .dn-business-detail,
  .dn-waybill,
  .dn-sub-header,
  .dn-city-cod,
  .dn-content-header,
  .dn-content,
  .dn-valign,
  .curfox-label {
    font-family: "Arial", sans-serif;
    color: black;
    font-weight: bolder !important;
  }
}
</style>
